<div class="toggle-button-container">
    <div class="form-check form-switch">
        <input
            [id]="idText"
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="isChecked"
            (change)="onToggleClick()" />
        <label *ngIf="toggleText" class="form-check-label" [for]="idText">{{ toggleText }}</label>
    </div>
</div>
